// WiseOwl API types
export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

// Responses
export type FetchChatByIdResponse = ApiResponse<ChatWithMessages>;
export type SendMessageResponse = ApiResponse<SendMessageData>;
export type CreateChatResponse = ApiResponse<CreateChatData>;
export type FetchChatHistoryResponse = ApiResponse<GetChatHistoryData>;

// Request Bodies & Params
export interface CreateChatRequestBody {
  input: string;
}

export interface SendMessageRequestBody {
  input: string;
}

export interface SendMessageParams {
  chatId: string;
  chatData: SendMessageRequestBody;
  bearerToken?: string;
}

export interface SendMessageData {
  chat: ChatWithMessages;
}

// Supporting objects
export interface ChatWithMessages extends Chat {
  messages: Message[];
}

export interface CreateChatData {
  chat: ChatWithMessages;
}

export interface GetChatHistoryData {
  chats: Chat[];
}

export interface Chat {
  createdAt: string;
  id: number;
  ingress: string;
  slackConversationId: string | null;
  slackThreadTimestamp: string | null;
  title: string;
  updatedAt: string;
  userId: string;
}

// Legacy message - only support temporarily for 1A
export interface Message {
  chatId: string;
  content: string;
  createdAt: string;
  id: string;
  messageRole: string;
  slackMessageTimestamp: string | null;
  toolCalls: Record<string, unknown>[];
  updatedAt: string;
  userId: string | null;
}

export enum DataSource {
  TwilioCom = "TWILIO_COM",
  SendGridCom = "SENDGRID_COM",
  SegmentCom = "SEGMENT_COM",
  HelpTwilioCom = "HELP_TWILIO_COM",
  AuthyCom = "AUTHY_COM",
  GoogleDrive = "GOOGLE_DRIVE",
  TwilioOrg = "TWILIO_ORG",
}

export enum Ingress {
  Web = "WEB",
}

export enum MessageRole {
  User = "USER",
  Assistant = "ASSISTANT",
  System = "SYSTEM",
}

export interface MessageContext {
  id: number;
  createdAt: string;
  updatedAt: string;
  messageId: number;
  dataSource: DataSource | string;
  title: string;
  content: string;
  url: string;
}
